import {
  MenuDietaryPreferencesButton,
  MenuDietaryPreferencesButtonV2,
  MenuDietaryPreferencesButtonsContainer,
  MenuDietaryPreferencesButtonsContainerV2,
  MenuDietaryPreferencesContainer,
  MenuDietaryPreferencesDescription,
  MenuDietaryPreferencesFooter,
  MenuDietaryPreferencesHeading,
  MenuDietaryPreferencesModalCloseButton,
  MenuDietaryPreferencesModalHeader,
  MenuDietaryPreferencesNotices,
  MenuDietaryPreferencesSubmitButton,
  MenuDietaryPreferencesToggle,
} from './components';

export const MenuDietaryPreferences = {
  Toggle: MenuDietaryPreferencesToggle,
  Container: MenuDietaryPreferencesContainer,
  Heading: MenuDietaryPreferencesHeading,
  Description: MenuDietaryPreferencesDescription,
  ButtonsContainer: MenuDietaryPreferencesButtonsContainer,
  ButtonsContainerV2: MenuDietaryPreferencesButtonsContainerV2,
  Button: MenuDietaryPreferencesButton,
  ButtonV2: MenuDietaryPreferencesButtonV2,
  Notices: MenuDietaryPreferencesNotices,
  SubmitButton: MenuDietaryPreferencesSubmitButton,
  ModalCloseButton: MenuDietaryPreferencesModalCloseButton,
  ModalHeader: MenuDietaryPreferencesModalHeader,
  Footer: MenuDietaryPreferencesFooter,
};
